fx.ns("shared.popups", class ServerError extends shared.popups.BasePersonPopup{
    
    constructor(data, text, reloadOnClose)
    {
        super(data, fx.get("assets").personNotHappy );
        this.contentWidth = 500;
        this.contentHeight = 230;

        this.reloadOnClose = reloadOnClose === undefined || reloadOnClose;
        this._text = text || fx.text("Nous n'avons pu joindre le serveur. Veuillez ré-essayer de nouveau, ou contacter <a href='/contact/' target='_blank'>notre service technique</a>");
    }

    create()
    {
        super.create();
 
        this.addChild(new fx.components.Text({text:fx.text("Une erreur est arrivée"), className:"title center"}));
        this.addChild(new fx.components.Text({text: this._text, className:"text center"}));

        this.addFooterChild("close");
    }

    onClose()
    {
        super.onClose();

        if (this.reloadOnClose)
            this.data.event("reload-page");
    }


});